import React, { useEffect, useRef } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import Logo from "@/components/Logo";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;

    const run = async () => {
      if (!sessionId) {
        window.location.replace("/");
        return;
      }
      try {
        const res = await api.post("/auth/session", { session_id: sessionId });
        setUser(res.data.user);
      } catch (error) {
        console.error("Error al procesar la sesión de Google:", error);
        // fall through, will redirect to login
      } finally {
        // Clean the hash and go to app root
        window.history.replaceState(null, "", "/");
        window.location.replace("/");
      }
    };
    run();
  }, [setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-5">
      <Logo size={72} className="animate-pulse" />
      <div className="flex items-center gap-3 text-[#2E6CA4]">
        <span className="w-5 h-5 border-2 border-[#2E6CA4] border-t-transparent rounded-full animate-spin360" />
        <span className="font-medium">Iniciando sesión…</span>
      </div>
    </div>
  );
}
